var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5405_9815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1L4 1.5V3.027C4.33232 2.99027 4.66768 2.99027 5 3.027V2H14V7H12.293L11 8.293V7H8.973C9.00973 7.33232 9.00973 7.66768 8.973 8H10V9.5L10.854 9.854L12.707 8H14.5L15 7.5V1.5L14.5 1H4.5Z",
    fill: "#99D7D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.417 10.4288C7.04759 10.016 7.52808 9.41067 7.78699 8.70285C8.04591 7.99503 8.06942 7.22254 7.85404 6.50028C7.63865 5.77802 7.19587 5.14458 6.59156 4.69418C5.98725 4.24378 5.25369 4.00049 4.5 4.00049C3.74631 4.00049 3.01275 4.24378 2.40844 4.69418C1.80413 5.14458 1.36135 5.77802 1.14596 6.50028C0.930575 7.22254 0.95409 7.99503 1.21301 8.70285C1.47192 9.41067 1.95241 10.016 2.583 10.4288C1.81072 10.7926 1.15781 11.3685 0.700454 12.0893C0.243102 12.8101 0.000168547 13.6461 0 14.4998L0 14.9998H1V14.4998C1.03069 13.592 1.41289 12.7317 2.06591 12.1004C2.71894 11.4691 3.5917 11.1162 4.5 11.1162C5.4083 11.1162 6.28106 11.4691 6.93409 12.1004C7.58711 12.7317 7.96931 13.592 8 14.4998V14.9998H9V14.4998C8.99983 13.6461 8.7569 12.8101 8.29955 12.0893C7.84219 11.3685 7.18928 10.7926 6.417 10.4288ZM4.5 9.99982C3.83696 9.99982 3.20107 9.73643 2.73223 9.26758C2.26339 8.79874 2 8.16286 2 7.49982C2 6.83678 2.26339 6.20089 2.73223 5.73205C3.20107 5.26321 3.83696 4.99982 4.5 4.99982C5.16304 4.99982 5.79893 5.26321 6.26777 5.73205C6.73661 6.20089 7 6.83678 7 7.49982C7 8.16286 6.73661 8.79874 6.26777 9.26758C5.79893 9.73643 5.16304 9.99982 4.5 9.99982Z",
    fill: "#99D7D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5405_9815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback1);
export default __webpack_public_path__ + "static/media/Feedback1.00e5e0ce8c23805cf53c3aecef115502.svg";
export { ForwardRef as ReactComponent };